/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Check = ["svg", defaultAttributes, [["path", { d: "M20 6 9 17l-5-5" }]]];

export { Check as default };
//# sourceMappingURL=check.js.map
